import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Accordion, AccordionPanel, Box, Heading, Text } from 'grommet'
import { SettingsOption } from 'grommet-icons'
import styled from 'styled-components'
import loadable from '@loadable/component'
// import SavedListsNames from './SavedListsNames'
import withLocation from '../HOC/withLocation'
import { RelativeBox } from '../Common'
import { setToolSettingsActiveIndex } from '../../redux/common/actions'
// import { useHideInput } from '../../contextHook/hideInput'

const Content = loadable(() => import('./Content'))

const Panel = styled(AccordionPanel)`
  & div h4 {
    margin-bottom: 0px;
    color: ${props => props.theme.global.colors.text};
  }
`
const Accord = styled(Accordion)`
  padding: 2rem 1.4rem;
  @media (max-width: 550px) {
    padding: 2rem 0.5rem;
  }
`

const SettingsShield = () => {
  return (
    <Box
      width="100%"
      height="100%"
      background="disabled"
      style={{ opacity: 0.5, position: 'absolute' }}
    ></Box>
  )
}

const ToolSettings = ({ size, urlLocation, page }) => {
  // const pathname = urlLocation.pathname
  // const { shareModeActive } = useHideInput()
  const { websiteMode, toolSettingsActiveIndex } = useSelector(
    state => state.common,
  )

  const dispatch = useDispatch()

  const shareModeActive =
    websiteMode !== 'Normal' && websiteMode !== 'ShareEditingMode'
  // const isRIG = pathname.includes("random-image-generator")
  // const isHomepage = pathname === "/"
  // const menuItems = isRTG
  //   ? ['Confetti & Sound', 'Tool Colors', 'Background Color']
  //   : ['Spin Behavior', 'Confetti & Sound', 'Tool Colors', 'Background Color']

  // const menuItems = isRTG
  //   ? [
  //       "Confetti & Sound",
  //       "Tool Colors",
  //       "Background Color",
  //       "Save Lists Names",
  //     ]
  //   : ["Spin Behavior", "Confetti & Sound", "Tool Colors", "Background Color"]
  // if (isHomepage || isRIG) {
  //   menuItems.push("Save Lists Names")
  // }

  // let page = "main"
  // if (isRTG) {
  //   page = "rtg"
  // } else if (isRIG) {
  //   page = "rig"
  // }
  const panelLabel = (
    <Box direction="row" align="center" gap=".3rem">
      <SettingsOption size="20px" color="iconDarkLight" />
      <Heading level={4}>Tool Settings</Heading>
      <Text weight={400} size="1.4rem">
        {!shareModeActive
          ? toolSettingsActiveIndex
            ? '(Click to Expand)'
            : '(Click to Collapse)'
          : '(Not Editable)'}
      </Text>
    </Box>
  )
  return (
    <RelativeBox
      background="baseBackground"
      // border="top"
      // background="rgb(252, 231, 181)"
      // background="rgb(217, 217, 217)"
      // round="2rem"
      // pad={{ vertical: "2.5rem", horizontal: "3rem" }}
    >
      <Accord
        activeIndex={toolSettingsActiveIndex} //1 equal close section, 0 equal to open section
        onActive={() => {
          dispatch(setToolSettingsActiveIndex(1 - toolSettingsActiveIndex))
        }}
      >
        <Panel label={panelLabel}>
          <Content
            page={page}
            // pathname={pathname}
            size={size}
            fallback={
              <Box
                height={size === 'medium' ? '49rem' : '33rem'}
                align="center"
                justify="center"
                background="baseBackground"
              >
                Loading...
              </Box>
            }
          />
        </Panel>
      </Accord>
      {shareModeActive && <SettingsShield />}
    </RelativeBox>
  )
}

export default withLocation(ToolSettings)
